import './App.css';
import { Navbar, SplashScreen, Footer } from '../components';
import { Outlet } from 'react-router-dom';
import Expire from '../utils/Expire';
import { useLocalStorage } from '../hooks/useLocalStorage';
// import { SplashScreen, Navbar } from "./components"
// import { Navbar } from './components';

function App() {
  // find out if user has dark theme set as preferred
  const defaultDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
  const [theme, setTheme] = useLocalStorage('theme', defaultDark ? 'dark' : 'light');

  // function to switch theme when user toggles the theme selector.
  const switchTheme = () => {
    const newTheme = theme === "light" ? "dark" : "light"
    setTheme(newTheme)
  }


  return (
    <>
    {/* <div className='App' data-theme={theme}> */}
    <div className='App' >
        <Expire delay="2500"><SplashScreen /></Expire>
        
        <div className="main_container">
          <div className="main_welcome">

          </div>
          <Navbar switchTheme={switchTheme} theme={theme} />
        <Outlet />
        </div>

        <Footer/>
    </div>
    </>
  );
}

export default App;
